import React, { useEffect, useRef } from "react";
import localeText from "../../../../../../locale";
import "./ProductCardMenu.css";

function ProductCardMenu({ visible, onClose, isPublished, onPublishToggle, onEdit, onNotifyUsers, onNotifyCircle, anchorRef }) {
  const menuRef = useRef(null);

  useEffect(() => {
    if (!visible) return undefined;

    const handleClick = (event) => {
      if (menuRef.current?.contains(event.target)) return;
      if (anchorRef?.current?.contains(event.target)) return;
      onClose?.();
    };

    const handleKey = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    document.addEventListener("mousedown", handleClick);
    document.addEventListener("keydown", handleKey);
    return () => {
      document.removeEventListener("mousedown", handleClick);
      document.removeEventListener("keydown", handleKey);
    };
  }, [visible, onClose, anchorRef]);

  if (!visible) return null;

  return (
    <div ref={menuRef} className="product-card-menu" role="menu">
      <button type="button" className="product-card-menu-item" onClick={onPublishToggle}>
        <i className={isPublished ? "pi pi-pause" : "pi pi-play"} />
        <span>{localeText(isPublished ? "unpublishProduct" : "publishProduct")}</span>
      </button>
      <button type="button" className="product-card-menu-item" onClick={onEdit}>
        <i className="pi pi-pencil" />
        <span>{localeText("editProduct")}</span>
      </button>
      <button type="button" className="product-card-menu-item" onClick={onNotifyUsers}>
        <i className="pi pi-envelope" />
        <span>{localeText("notifyUsers")}</span>
      </button>
      <button type="button" className="product-card-menu-item" onClick={onNotifyCircle}>
        <i className="pi pi-send" />
        <span>{localeText("notifyEconomicCircle")}</span>
      </button>
    </div>
  );
}

export default ProductCardMenu;
